module.exports = __webpack_public_path__ + "static/media/none.3aa632ab.jpg";